import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { ImEarth } from "react-icons/im";
import { SiGmail } from "react-icons/si";
import { goToPricing } from "../../helper/functions";
import { StyledFooter } from "./styled";

const Footer = () => {
  return (
    <StyledFooter>
      <div className="main-row">
        <div className="col-1">
          <h1 className="brandname">WhatQR</h1>
          <span>Generate QRs and short urls in seconds</span>
          <div className="social">
            <h2>Online presence</h2>
            <div className="social-media">
              <FaLinkedin
                onClick={() => {
                  window.open("https://linkedin.com/in/shubham-waje", "_blank");
                }}
              />
              <FaGithub
                onClick={() => {
                  window.open("https://github.com/wajeshubham", "_blank");
                }}
              />
              <ImEarth
                onClick={() => {
                  window.open("https://wajeshubham.in", "_blank");
                }}
              />
              <SiGmail
                onClick={() => {
                  window.open("mailto:acc.whatqr@gmail.com", "_blank");
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-2">
          <h2>Quick links</h2>
          <ul>
            <li>
              <a href="/dashboard">Dashboard</a>
            </li>
            <li>
              <a href="/generate/qr">Generate QRs</a>
            </li>
            <li>
              <a href="/generate/url">Generate short urls</a>
            </li>
            <li>
              {/* eslint-disable-next-line */}
              <a
                style={{ cursor: "pointer" }}
                onClick={() => {
                  goToPricing();
                }}
              >
                Pricing
              </a>
            </li>
            <li>
              <a href="/profile">My Account</a>
            </li>
          </ul>
        </div>
        <div className="col-3">
          <h2>About & help</h2>
          <ul>
            <li>
              <a href="/privacy-policy">Privacy policy</a>
            </li>
            <li>
              <a href="/terms-conditions">Terms and conditions</a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://hashnode.com/@wajeshubham"
              >
                Programming blogs
              </a>
            </li>
            <li>
              <a href="/contact">Contact us</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="bottom-row">
        <p>
          @2022 <strong>WhatQR</strong>. All rights reserved.
        </p>
      </div>
    </StyledFooter>
  );
};

export default Footer;
